import { render } from "./JournalImageUploader.vue?vue&type=template&id=2f02c6a2"
import script from "./JournalImageUploader.vue?vue&type=script&lang=js"
export * from "./JournalImageUploader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__